module.exports = __webpack_public_path__ + "2a3d81fc642eb7aac8c1c43081c6e668.png";